/**
* Society Links Module
* Any Society Links related Javascript will go here.
*/
var SCM = SCM || {};
SCM.Utilities = SCM.Utilities || {};

// replace place holder origurl query string parameter value with the current url
SCM.AddReturnUrlToSocietyLinks = function () {

    var returnUrl = GetReturnUrl();
    returnUrl = encodeURIComponent(returnUrl);
    var placeholderHf = $('#hfPlaceholderReturnUrlValue');
    var placeholder = placeholderHf.length ? placeholderHf.val() : null;

    $('.society-links-logo, .society-links-url').each(function () {
        if (placeholder && placeholder.length)
        {
            var $this = $(this);
            $this.attr('href', $this.attr('href').replace(placeholder, returnUrl));
        }
    });
};

function GetReturnUrl() {
    
    // remove the login=true param before sending to society login
    var returnUrl = window.location.href;
    if (returnUrl.indexOf('?') > 0) {
        var queryParts = window.location.search.split('&');
        returnUrl = returnUrl.substring(0,returnUrl.indexOf('?'));
        if (queryParts.length) {
            var queryPartsWithoutLogin = queryParts.filter(function (el) {
                var paramType = el.split('=')[0].replace('?', '');
                return paramType !== 'login';
            });
            if (queryPartsWithoutLogin.length) {
                returnUrl += queryPartsWithoutLogin.join('&');
            }
        }
        returnUrl += window.location.hash;
    }
    return returnUrl;
}